import React from "react";

const Leaves = () => {
  return (
    <div className="container mt-4">
      <h4>Leaves</h4>

      {/* Stats */}
      <div className="row mb-3">
        {["Total","Planned","Unplanned","Pending"].map((t,i) => (
          <div key={i} className="col-md-3">
            <div className="card p-3 text-center">
              <h6>{t}</h6>
              <strong>{i * 5 + 10}</strong>
            </div>
          </div>
        ))}
      </div>

      {/* Table */}
      <div className="card p-3">
        <table className="table">
          <thead>
            <tr>
              <th>Employee</th>
              <th>Type</th>
              <th>From</th>
              <th>To</th>
              <th>Days</th>
            </tr>
          </thead>

          <tbody>
            {[1,2,3].map(i => (
              <tr key={i}>
                <td>Antony</td>
                <td>Medical</td>
                <td>14 Jan</td>
                <td>15 Jan</td>
                <td>2</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Leaves;